const _ = require("lodash");
const setIn = require("../ImmHelpers").setIn;

// NOTE: ropeClimbDrill generalizes arithmeticDrill, so all future new things should use ropeClimbDrill.
// We are keeping arithmeticDrill for backwards compatibility purposes, since two lessons still use it.

const settings = {
	allowRepeatTrials: true,
	staticMaxStars: true,
	neverShowSliderMessages: true,
	neverSetOutcome: true,
	noUndoRedoClear: true,
	saveAllProblems: true,
	starProgressType: "static",
	noProblemHistory: true,
	skipProblemCount: true,
};

const initialize = function(result, processor) {
	const p = result.problems[0];
	p.customState = processor.setupCustomState(p.model, p.customState, p.trials);
	p.model.initialProblemData = p.customState.trial
		? p.customState.trial.problemData
		: processor.generateProblem(p.model, {
				status: p.customState.status,
				trials: [],
		  }).problemData;
};

const computeBackendProgress = function(result, defaultProgress) {
	const progress = _.extend({}, defaultProgress, {
		problems: defaultProgress.problems
			.map(p =>
				setIn(
					p,
					"customState",
					_.omit(p.customState, ["solutionBatex", "trialCorrects"])
				)
			)
			.map((p, i) =>
				setIn(
					p,
					"trials",
					p.trials.map(
						(t, j) => result.problems[i].processedTrials[j].encodedTrial
					)
				)
			),
	});
	return progress;
};

const computeBackendTrial = function(result, problem, backendTrial) {
	return _.extend({}, backendTrial, {
		response: {
			response: backendTrial.response.response.answerAttempt.map(n =>
				parseInt(n)
			),
		},
		problemData: backendTrial.response.response.problemData,
		outcome: problem.customState.currentOutcome,
		final: true,
		attemptNumber: 1,
	});
};

const getStars = function(result) {
	return result.starsAvailable;
};

const getPercentComplete = function(result) {
	const problem = result.problems[0];
	if (problem.customState.isFinished) {
		return 1;
	}
	const status = problem.customState.status;
	const numBeasts = status.length;
	const maxLevel = problem.customState.maxLevel || 5;

	const sumLevels = _.reduce(status, (sum, n) => {
		return sum + n;
	});
	return sumLevels / (numBeasts * maxLevel) || 0;
};

const getTrialXP = function(result) {
	return 1;
};

const canGoToNextProblem = function(result) {
	return true;
};

const goToNextProblem = function(result) {
	return setIn(result, ["problems", 0], problem => {
		const newCustomState = _.cloneDeep(problem.customState);
		return _.extend({}, problem, {outcome: false, customState: newCustomState});
	});
};

const isFinished = function(result) {
	const currentProblem = result.problems[0];
	return !!currentProblem.outcome || !!currentProblem.customState.isFinished;
};

const isCurrentProblemDone = function(result) {
	return isFinished(result);
};

const processPostSubmission = function(result, processor) {
	const currentProblem = result.problems[0];
	const problemModel = currentProblem.model;
	const customState = currentProblem.customState;
	const newCustomState = processor.updateCustomState(
		problemModel,
		customState,
		currentProblem.trials
	);
	return setIn(result, ["problems", 0, "customState"], newCustomState);
};

const getResultProgressXP = function(backendResult) {
	const {progress} = backendResult;
	const numCorrect = _.get(progress, "problems.0.customState.numCorrect") || 0;
	return numCorrect * getTrialXP();
};

const getSummaryProblemsSolvedText = function(result) {
	return "All the number beasts have made it to the top!";
};

const getStarProgressInfo = function(result) {
	return {
		styleType: result.styleType,
		filledAmount: getPercentComplete(result),
		totalAmount: 1,
		starsAvailable: result.starsAvailable,
		starsEarned: isFinished(result) ? result.starsAvailable : 0,
	};
};

const getSummaryForReport = function(backendResult) {
	const customState = _.get(backendResult, "progress.problems[0].customState");
	if (!customState) {
		return "Problems cannot be displayed for this game lesson.";
	} else {
		const {submissions, numCorrect} = customState;
		if (_.isInteger(numCorrect)) {
			return `${numCorrect}/${submissions} problems answered correctly.`;
		} else {
			return `${submissions} problems answered.`;
		}
	}
};

module.exports = {
	settings,
	initialize,
	getStars,
	getPercentComplete,
	getTrialXP,
	canGoToNextProblem,
	goToNextProblem,
	processPostSubmission,
	isFinished,
	computeBackendProgress,
	computeBackendTrial,
	getResultProgressXP,
	isCurrentProblemDone,
	getSummaryProblemsSolvedText,
	getStarProgressInfo,
	getSummaryForReport,
};
